/**
 * 系统通知静态兜底（开发联调可用）。正式数据由 systemAnnouncementAPI 拉取。
 * @type {Array<{ id: string, title: string, message: string, createdAt: string, actionLabel?: string, actionUrl?: string }>}
 */
export const SYSTEM_NOTIFICATIONS = [];
